import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";
import Head from "../Head";
import Footer from "../../components/Footer";
import { languageData } from "../../constants/languageData";

const FlipScreen = ({setIsFlipScreenProcessed, stepperFunc, steps, hideHeader = false, hideContinueBtn = false }) => {
    const container = useRef(null);
    const language = sessionStorage.getItem("language") ?? "en";

    useEffect(() => {
        const anim = lottie.loadAnimation({
            container: container.current,
            renderer: "svg",
            loop: true,
            autoplay: true,
            path: "/ID_BACK.json",
        });
        anim.setSpeed(1.6);
        return () => anim.destroy();
    }, []);

    useEffect(() => {
        const isShown = sessionStorage.getItem('isFlipScreenShown');
        if(!isShown) sessionStorage.setItem('isFlipScreenShown','1');

        if (hideContinueBtn){
            setTimeout(() => {
                setIsFlipScreenProcessed(true);
            }, 1800);
        }
    }, []);

    return (
        <>
            {!hideHeader && <Head
                style={{ zIndex: "100" }}
                handleBack={() => {
                    sessionStorage.removeItem('isFlipScreenShown');
                    stepperFunc(steps[2])
                  }
                }
                showLanguages={false}
                showBackIcon
                showHelp={false}
                showMobileFlow={false}
            />}
            <div className="parent-container">
                <div className="main">
                    {/* Left Section with Black Background */}
                    <div className="left-section" style={{
                        backgroundColor: 'black',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                        <div
                            ref={container}
                            className="w-[250px] h-[250px] md:w-[300px] md:h-[300px]"
                        />
                    </div>

                    {/* Right Section with Content */}
                    <div
                        className="right-section md:items-start items-center"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            gap: 24,
                            fontFamily: "Inter, sans-serif",

                        }}
                    >
                        <div className="flex flex-col md:text-start text-center items-start self-stretch">
                            <div>
                                <div className="text-[18px] md:text-[28px] flex items-baseline font-semibold text-[#000000] md:justify-start justify-center md:text-left mt-4 md:mt-0">
                                    {languageData[language]?.flipScreen?.heading ?? "Now flip your ID card"}
                                </div>
                                <div className="md:mt-4 md:mb-4 mt-6 mb-6 text-[12px] md:text-[16px] font-semibold text-[#656565] text-center md:text-left">
                                    {languageData[language]?.flipScreen?.subHeading ??
                                        "Please physically flip your ID card to show the back side, then position it in the camera frame."}
                                </div>
                            </div>

                        </div>
                        {/* Continue Button with proper spacing */}
                        <div className="flex flex-col justify-center w-full"> {/* Added margin-bottom */}
                            {!hideContinueBtn && <button
                                className="w-full py-4 px-6 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-[16px] font-medium"
                                onClick={() => {
                                    setIsFlipScreenProcessed(true);
                                }}
                            >
                                {languageData[language]?.flipScreen?.continueButton ?? "Continue"}
                            </button>}
                            <Footer />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FlipScreen;

